<div class="modal-header p-0">
    <button
            type="button"
            class="close"
            (click)="close()"
    >
        <img src="assets/icons/close.png" alt="close-icon"/>
    </button>
</div>
<div class="modal-body d-flex justify-content-center ">
    <lib-video-player [videoId]="videoId"></lib-video-player>
</div>

